<template>
  <div v-if="totalCount && totalCount > 0">
    <progress-bar
      class="progress-bar"
      :items="items"
      :showLabel="showLabel"
      :showPercent="showPercent"
    />
  </div>
</template>

<script setup>
  import ProgressBar from '@/components/projects/management/ProgressBar.vue';
  import {
    STATUS_COMPLETED,
    STATUS_COMPLETED_OVERDUE,
    STATUS_INCOMPLETE,
    STATUS_INCOMPLETE_OVERDUE,
  } from '@/api/models/Checkpoint';
  import { computed, onMounted, ref, watch } from 'vue';

  const items = ref([]);

  const props = defineProps({
    showLabel: {
      type: Boolean,
      default: false,
    },
    showPercent: {
      type: Boolean,
      default: true,
    },
    completed: {
      type: Number,
      default: 0,
    },
    completedOverdue: {
      type: Number,
      default: 0,
    },
    incompleteOverdue: {
      type: Number,
      default: 0,
    },
    incomplete: {
      type: Number,
      default: 0,
    },
    partnerMode: {
      type: Boolean,
      default: false,
    },
  });

  const totalCount = computed(() => {
    return (
      props.completed +
      props.completedOverdue +
      props.incomplete +
      props.incompleteOverdue
    );
  });

  onMounted(() => {
    getItems();
  });

  watch(
    [
      () => props.incomplete,
      () => props.incompleteOverdue,
      () => props.completed,
      () => props.completedOverdue,
    ],
    () => getItems()
  );

  const getItems = () => {
    if (props.partnerMode) {
      items.value = [
        ...new Array(props.completed + props.completedOverdue).fill({
          status: STATUS_COMPLETED,
        }),
        ...new Array(props.incomplete + props.incompleteOverdue).fill({
          status: STATUS_INCOMPLETE,
        }),
      ];
    } else {
      items.value = [
        ...new Array(props.completed).fill({ status: STATUS_COMPLETED }),
        ...new Array(props.completedOverdue).fill({
          status: STATUS_COMPLETED_OVERDUE,
        }),
        ...new Array(props.incompleteOverdue).fill({
          status: STATUS_INCOMPLETE_OVERDUE,
        }),
        ...new Array(props.incomplete).fill({ status: STATUS_INCOMPLETE }),
      ];
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .progress-bar {
    color: $color-text-primary;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
</style>
